import { Directive, ElementRef } from '@angular/core';

@Directive({
	selector: '[inlineAnchor]',
	exportAs: 'inlineAnchor'
})
export class InlineAnchorDirective {
  constructor(public element: ElementRef) {}
}
